import React from 'react';
import Slider from 'react-slick';

const carImages = [
  'images/resource/car.png',
  'images/resource/volvo.jpg',
  'images/resource/new_BMW.jpg',
];

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows: false,
};

const CarsSection = () => {
  return (
    <section className="cars-section">
      <div className="auto-container">
        <div className="content-container">
          <div className="row clearfix">
            {/* Left Content Column */}
            <div className="content-column col-md-7 col-sm-12 col-xs-12">
              <div className="inner-box">
                <div className="sec-title">
                  <div className="inner-title-box">
                    <h2>
                     Rent a corporate car<br />from the experts
                    </h2>
                    <h4 className="rotate-title darkcolorrr">e-Travo</h4>
                  </div>
                </div>
                <div className="dark-text">
                 Our corporate car rental services are reliable for businesses. Is it necessary to have a fleet of sedans, SUVs, INNOVA CRYSTAs, 17 Seater AC buses, 26 Seater AC buses, 32 Seater AC buses, 45 Seater AC buses, 49 Seater AC buses, 56 Seater AC Volvos . Since 2011, we have been one of the leading Luxury Car Rental Agencies in India and provide 24-hour support before, during, and after your trip.
                </div>
                <div className="text">
                 You can also contact our team with any questions or concerns. Before driving for us, our chauffeurs undergo rigorous training

                </div>
                <a href="/booking" className="theme-btn btn-style-one">
                 Book Luxury Cabs and Bus
                </a>
              </div>
            </div>

            {/* Right Carousel Column */}
            <div className="carousel-column col-md-5 col-sm-12 col-xs-12">
              <h2>CADILLAC ESCALADE LIMO</h2>
              <Slider {...sliderSettings} className="single-item-carousel">
                {carImages.map((src, idx) => (
                  <div key={idx} className="car-item">
                    <figure className="image">
                      <img src={src} alt={`Car ${idx + 1}`} />
                    </figure>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CarsSection;
